// extracted by mini-css-extract-plugin
export default {"wrapper":"FIzenw","buttonsContainer":"VYDk5Y","button":"e47Vp1"};